<template>
	<auth-container :page="page">
		<h2 class="mb-4">Create New Construction Phase</h2>

		<sr-construction-form :item="item" :project="project" :agreement="null" :showNoExist="showNoExist"></sr-construction-form>
	</auth-container>
</template>

<script>
	import SrConstructionForm from './SrConstructionForm.vue';
	export default {
		name: 'SrConstructionCreate',
		components: {
			SrConstructionForm
		},
		data() {
			return {
				page: {
					errors: [],
					loading: false,
					showLogin: false
				},
				item: {
					projectId: null,
					bidEngEst: 0,
					bidEngEstDate: null,
					bidEngEstNotes: null,
					contingencyPercent: 0,
					federalCostSharePercent: 0,
					federalCostShareAmount: 0,
					stateCostSharePercent: 0,
					stateCostShareAmount: 0,
					sponsorCostSharePercent: 0,
					sponsorCostShareAmount: 0,
					sponsorAdminCostSharePercent: 0,
					sponsorAdminCostShareAmount: 0,
					finalBid: 0,
					finalBidDate: null,
					finalCost: 0,
					asBuiltReceivedDate: null,
					asBuiltNotes: null,
					oversightAgent: null,
					assignedAe: null,
					aeProfCapacity: null,
				},
				project: null,
				shoNoExist: false
			}
		},
		async created() {
			await this.get();
		},
		watch: {
			'$route': 'get'
		},
		methods: {
			async get() {
				this.page.loading = true;
				this.page.errors = [];

				if (!this.isNullOrEmpty(this.$route.query.projectId)) {
					try {
						const response = await this.$http.get(`srprojects/getname/${this.$route.query.projectId}`, this.getTokenHeader());
						this.project = response.data;
						this.showNoExist = true;
					} catch (error) {
						if (this.isApiUnauthorized(error)) this.page.showLogin = true;
						else this.page.errors = this.logError(error);
					}
				}

				this.page.loading = false;
			}
		}
	}
</script>